/* eslint-disable no-undef */
export default function ForceBugReport() {
  return (
    <div className="layout_content wrapperMobile">{test ? <TEST /> : null}</div>
  );
}
